import React from 'react';
import { CircularProgress, Grid2 } from '@mui/material';
import { useGetIntegrations } from '@openapi/integrations/integrations';
import { useGetShow } from '@openapi/shows/shows';
import useNotify from '../../hooks/useNotify';
import PageWithTitle from '../../components/atom/PageWithTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { INTEGRATION_TYPES } from '../../helpers/constants';
import IntegrationCard from './components/IntegrationCard';

const IntegrationsPage = () => {
    const { t } = useTranslation();
    const { notifyError } = useNotify();
    const { showId } = useParams();
    const navigate = useNavigate();

    const {
        data,
        isLoading: loading,
        _error,
    } = useGetIntegrations(
        {
            optionalId: showId,
            pageSize: 100,
        },
        {
            query: {
                onError: notifyError,
            },
        },
    );

    const {
        data: show,
        isLoading: loadingShow,
        error: _errorShow,
    } = useGetShow(Number(showId), {
        query: {
            onError: notifyError,
        },
    });

    // Create a map of existing integrations by type
    const integrationsMap = {};
    if (data?.integrations) {
        data.integrations.forEach((integration) => {
            integrationsMap[integration.type] = integration;
        });
    }

    // Build list of ALL integration types (existing + missing)
    const allIntegrations = Object.values(INTEGRATION_TYPES).map((type) => {
        if (integrationsMap[type]) {
            return integrationsMap[type];
        }
        // Return a default "disabled" integration if it doesn't exist in DB
        return {
            type,
            settings: {},
            enabled: false,
        };
    });

    return (
        <PageWithTitle
            title={`${t('integrations.title')} (${loadingShow ? '' : show?.title || ''})`}
        >
            <Grid2
                container
                spacing={2}
                sx={{
                    width: '100%',
                    margin: 0,
                }}
            >
                {loading && <CircularProgress size={20} style={{ margin: '20px auto' }} />}
                {allIntegrations.map((integration) => (
                    <Grid2 key={integration.type} size={{ xs: 12, sm: 6, md: 3 }}>
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <IntegrationCard
                                integration={integration}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/shows/${showId}/integrations/${integration.type}`);
                                }}
                            />
                        </div>
                    </Grid2>
                ))}
            </Grid2>
        </PageWithTitle>
    );
};

export default IntegrationsPage;
